import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { deviceService } from "../../utils/deviceService";
import { DeviceType } from "../../models/constants/deviceType";

interface BottomDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  deviceType?: string;
}

export function BottomDrawer({
  open,
  onClose,
  children,
  className,
  deviceType = DeviceType.Web,
}: BottomDrawerProps) {
  const [visible, setVisible] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (open) {
      setVisible(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setShouldAnimate(true);
        });
      });
    } else {
      setShouldAnimate(false);
    }
  }, [open]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const handleTransitionEnd = () => {
    if (!open) setVisible(false);
  };

  if (!visible) return null;

  return createPortal(
    <>
      <div
        className={`fixed inset-0 z-40 bg-black/60 transition-opacity duration-300 pointer-events-auto ${shouldAnimate ? "opacity-100" : "opacity-0"
          }`}
        onClick={onClose}
      />

      <div
        onTransitionEnd={handleTransitionEnd}
        className={`
          shadow-[0px_-4px_40px_0px_#242323]
          fixed inset-x-0 ${deviceType === DeviceType.Web ? "bottom-[5px]" : "bottom-[75px]"}  z-50
          pointer-events-auto
          max-h-[85vh]
          rounded-t-3xl          
          border-[1.5px] border-[#353535]
          border-b-0
          bg-black
          transition-all duration-500 ease-out 
          ${className}
          ${shouldAnimate ? "translate-y-0" : "translate-y-full"}
        `}
      >
        <div
          className="flex justify-center pt-3 pb-2 "
          onClick={onClose}
          role="button"
        >
          <div className="h-2 w-12 rounded-full bg-white/30 cursor-pointer hover:bg-white/50" />
        </div>

        <div className="overflow-y-auto px-4 pb-6">{children}</div>
      </div>
    </>,
    document.body,
  );
}
